import { Error } from './Error';
import { RowsError } from './RowError';

type Props = {
  error: string;
  erroredRowIndex: number | null;
  onDismiss: () => void;
  onRangeClick: (row: number) => void;
};

export const AnalysisError = ({
  error,
  erroredRowIndex,
  onDismiss,
  onRangeClick,
}: Props) => {
  return (
    <Error onDismiss={onDismiss}>
      <RowsError errorType="analysis">
        {error}
        {` `}
        {erroredRowIndex && (
          <button onClick={() => onRangeClick(erroredRowIndex)}>
            <span className="underline">Go to row {erroredRowIndex}</span>
          </button>
        )}
      </RowsError>
    </Error>
  );
};
